var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_setup.isShow),expression:"isShow"}],staticClass:"base-table__top-scroll",attrs:{"data-test-id":"top-scroll"}},[_c('div',{ref:"topScrollBar",staticClass:"base-table__top-scroll-bar",attrs:{"data-test-id":"top-scroll-bar"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }